








import {
  defineComponent,
  PropType,
  computed,
  toRefs
} from '~/utils/nuxt3-migration'
import { ciCarcheck } from '~/icons/source/regular/carcheck'
import { CategoryId } from '~/models/category/types'
import { ciBikeCheck } from '~/icons/source/regular/bike-check'
import { ciVanCheck } from '~/icons/source/regular/van-check'

export default defineComponent({
  props: {
    category: {
      type: Number as PropType<CategoryId>,
      required: false,
      default: CategoryId.CARS
    }
  },
  setup(props) {
    const { category } = toRefs(props)

    const btnIcon = computed(() => {
      switch (category.value) {
        case CategoryId.BIKES: {
          return ciBikeCheck
        }
        case CategoryId.VANS: {
          return ciVanCheck
        }
        case CategoryId.CARS:
        default: {
          return ciCarcheck
        }
      }
    })
    return {
      btnIcon
    }
  }
})
